module.exports = __webpack_public_path__ + "static/img/testBgItem2.bc5946d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testBgItem2.png
// module id = FMwb
// module chunks = 1